interface Cache {
  dateTime: Map<string, Intl.DateTimeFormat>;
  number: Map<string, Intl.NumberFormat>;
}

const CACHE: Cache = {
  dateTime: new Map(),
  number: new Map(),
};

export const getDateTimeFormatter = (
  locale: MatchiLocale,
  options?: Intl.DateTimeFormatOptions,
) => {
  let key = locale + JSON.stringify(options);
  let formatter = CACHE.dateTime.get(key);

  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, options);
    CACHE.dateTime.set(key, formatter);
  }

  return formatter;
};

export const getNumberFormatter = (
  locale: MatchiLocale,
  options?: Intl.NumberFormatOptions,
) => {
  let key = locale + JSON.stringify(options);
  let formatter = CACHE.number.get(key);

  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options);
    CACHE.number.set(key, formatter);
  }

  return formatter;
};
